export const initialState = {
  actionProcessing: false,
  totalInfo: {
    credits: null,
    debits: null,
    total: null,
  },
  users: [],
};
